import Types from "../../conf/types";
export const accessories = [
  {
    name: Types.eyes,
    items: ["eyes1.png", "eyes2.png", "eyes3.png", "eyes4.png", "eyes5.png"],
  },
  {
    name: Types.hairs,
    items: [
      "hairs1.png",
      "hairs2.png",
      "hairs3.png",
      "hairs4.png",
      "hairs5.png",
    ],
  },
  {
    name: Types.mouth,
    items: [
      "mouth1.png",
      "mouth2.png",
      "mouth3.png",
      "mouth4.png",
      "mouth5.png",
    ],
  },
  {
    name: Types.body,
    items: ["body1.png", "body2.png", "body3.png", "body4.png", "body5.png"],
  },
  {
    name: Types.bottoms,
    items: [
      "bottoms1.png",
      "bottoms2.png",
      "bottoms3.png",
      "bottoms4.png",
      "bottoms5.png",
    ],
  },
];
